import React, { useState } from 'react';
import { AlertTriangle, Plus, X } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';

const ClientStatusesSection = ({ settings, setSettings }) => {
  const [newStatus, setNewStatus] = useState('');
  const statuses = settings?.client_statuses || [];

  const addStatus = () => {
    if (newStatus.trim() && !statuses.includes(newStatus.trim().toUpperCase())) {
      setSettings({
        ...settings,
        client_statuses: [...statuses, newStatus.trim().toUpperCase()]
      });
      setNewStatus('');
    }
  };

  const removeStatus = (status) => {
    setSettings({
      ...settings,
      client_statuses: statuses.filter(s => s !== status)
    });
  };

  return (
    <div style={{
      backgroundColor: COLORS.card,
      borderRadius: '12px',
      padding: '20px',
      border: `1px solid ${COLORS.border}`,
      marginBottom: '16px',
    }}>
      <h3 style={{ color: COLORS.text, fontSize: '16px', fontWeight: '600', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <AlertTriangle size={20} color={COLORS.primary} />
        Статусы клиентов
      </h3>
      
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
        {statuses.map(status => (
          <div key={status} style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            backgroundColor: COLORS.background,
            borderRadius: '6px',
          }}>
            <span style={{ color: COLORS.text, fontSize: '13px' }}>{status}</span>
            <button
              onClick={() => removeStatus(status)}
              style={{ background: 'none', border: 'none', color: COLORS.danger, cursor: 'pointer', padding: 0 }}
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
      
      <div style={{ display: 'flex', gap: '8px' }}>
        <input
          type="text"
          value={newStatus}
          onChange={(e) => setNewStatus(e.target.value)}
          placeholder="Новый статус..."
          onKeyPress={(e) => e.key === 'Enter' && addStatus()}
          style={{
            flex: 1,
            padding: '10px 12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px',
          }}
        />
        <button
          onClick={addStatus}
          style={{
            padding: '10px 16px',
            backgroundColor: COLORS.primary,
            border: 'none',
            borderRadius: '8px',
            color: '#000',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          <Plus size={16} /> Добавить
        </button>
      </div>
    </div>
  );
};

export default ClientStatusesSection;
